module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.name === 'Order' || _vm.$route.name === 'OrderIframe') ? _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.loading) ? _c('loading', {
    attrs: {
      "message": "Загружаем информацию о заказе..."
    }
  }) : _c('div', {
    staticClass: "order-view"
  }, [_c('h3', {
    staticClass: "mb-2 h3"
  }, [_vm._v("Заказ №" + _vm._s(_vm.order.id) + " - " + _vm._s(_vm.order.description))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block order-view__block order-view__block--bordered"
  }, [_c('order-status', {
    attrs: {
      "order": _vm.order,
      "showSum": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card-block order-view__block order-view__block--bordered"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 text-muted"
  }, [_vm._v("Дата")]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(_vm._s(_vm.order.date))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 text-muted"
  }, [_vm._v("Время")]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(_vm._s(_vm.order.time))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 text-muted"
  }, [_vm._v("Город")]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(_vm._s(_vm.order.techcenter.city.name))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 text-muted"
  }, [_vm._v("Адрес")]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(_vm._s(_vm.order.techcenter.address))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block order-view__block order-view__block--bordered"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 text-muted"
  }, [_vm._v("Клиент")]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(_vm._s(_vm.order.clientName))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 text-muted"
  }, [_vm._v("\n                Телефон\n                "), (_vm.order.clientPhone === '**********') ? _c('span', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "text-danger",
    attrs: {
      "title": "Номер телефона клиента открывается за 1 час до приезде клиента, а также доступен при статусе 'В работе'. Если вам необходимо связаться с клиентом, то свяжитесь с ответственным мереджером в отделе продаж"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_vm._v("+7" + _vm._s(_vm.order.clientPhone))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-block order-view__block"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 text-muted"
  }, [_vm._v("Ответственный")]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(_vm._s(_vm.order.user.firstname) + "\n                " + _vm._s(_vm.order.user.lastname) + "\n              ")])]), _vm._v(" "), (_vm.order.sum) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 text-muted"
  }, [_vm._v("Сумма по заказ-наряду")]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(_vm._s(_vm.order.sum) + " "), _c('i', {
    staticClass: "fa fa-rub"
  })])]) : _vm._e(), _vm._v(" "), (_vm.order.profit) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 text-muted"
  }, [_vm._v("Комиссия")]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(_vm._s(_vm.order.profit) + " "), _c('i', {
    staticClass: "fa fa-rub"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 text-muted"
  }, [_vm._v("Создан")]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_vm._v(_vm._s(_vm.order.created))])]), _vm._v(" "), (_vm.order.amoId && !_vm.$route.meta.isIframe) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 text-muted"
  }, [_vm._v("Id в amoCRM")]), _vm._v(" "), _c('div', {
    staticClass: "col-7"
  }, [_c('a', {
    attrs: {
      "href": 'https://alarmru.amocrm.ru/leads/detail/' + _vm.order.amoId,
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.order.amoId) + "\n                ")])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('comments', {
    attrs: {
      "order": _vm.order
    }
  }), _vm._v(" "), _c('order-history', {
    attrs: {
      "order": _vm.order
    }
  })], 1)])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-1db223d4"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Orders/View.vue
// module id = 1003
// module chunks = 1